import { apiCallPost } from "../api"
import { apiPaths } from "../config/apiPaths";

export const editProductsApi = async (inputData,authHeaders) => {
    // Implement the API call to fetch products data
    const apiInputData = { ...inputData, channel: "CRM", apiVerb: "UPDATE" };

    try {
        const res = await apiCallPost(apiPaths.addProducts, apiInputData, authHeaders);
        // console.log('updateProduct', res);
        if (res?.id) {
        return { data: { id: res.id }, status: true, msg: 'Product Updated Successfully.' }
        }
        return { data: [], status: false, msg: res.msg ? res.msg : 'Error Occured Please Try Again.' };
    } catch (err) {
        return { status: false, errMsg: err.message };
    }
};
